import React, {useEffect, useState} from 'react';
import {Head } from "../../components";
import Api from "../../utils/api";
import "./style.css"

const Index = () => {

    const [data , setData] = useState()

    useEffect(() => {
        new Api().get('/notifications/text').then((res) => {
            setData(res.data)
        })
    } ,[])

    return(
        <div className={"sms"} style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'متن ارسال پیامک ایمیل و ...' }} />


            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>متن</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data?.map((entity, index) => {
                        return(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{entity.text}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default Index;